import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface NetworkState {
    isOnline: boolean;
    isWeak: boolean;
}

const initialState: NetworkState = {
    isOnline: navigator.onLine,
    isWeak: false,
};

const networkSlice = createSlice({
    name: 'network',
    initialState,
    reducers: {
        setNetworkStatus: (state, action: PayloadAction<{ isOnline: boolean; isWeak: boolean }>) => {
            state.isOnline = action.payload.isOnline;
            state.isWeak = action.payload.isWeak;
        },
        setIsOnline: (state, action: PayloadAction<boolean>) => {
            state.isOnline = action.payload;
        },
        setIsWeak: (state, action: PayloadAction<boolean>) => {
            state.isWeak = action.payload;
        }
    },
});

export const { setNetworkStatus, setIsOnline, setIsWeak } = networkSlice.actions;
export default networkSlice.reducer;